import React from 'react';
import { Box, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { ContentContainer } from 'components/styles_components/container';
import { ChapterTypography } from 'components/styles_components/typography';

const Section = ({ titleId, children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
      <FormattedMessage id={titleId} />
    </Typography>
    {children}
  </Box>
);

const P = ({ id }) => (
  <Typography variant="body1" sx={{ mb: 1 }}>
    <FormattedMessage id={id} />
  </Typography>
);

const Li = ({ id }) => (
  <Typography variant="body1" component="li" sx={{ ml: 3, mb: 0.5 }}>
    <FormattedMessage id={id} />
  </Typography>
);

const PaymentTerms = () => {
  return (
    <ContentContainer maxWidth="md">
      <ChapterTypography variant="h5" align="center">
        <FormattedMessage id="legal.payment.title" />
      </ChapterTypography>
      <Typography variant="subtitle1" align="center" sx={{ mb: 4 }}>
        <FormattedMessage id="legal.payment.subtitle" />
      </Typography>

      <Section titleId="legal.payment.s1.title">
        <P id="legal.payment.s1.p1" />
        <P id="legal.payment.s1.p2" />
        <P id="legal.payment.s1.p3" />
        <P id="legal.payment.s1.p4" />
        <P id="legal.payment.s1.p5" />
      </Section>

      <Section titleId="legal.payment.s2.title">
        <P id="legal.payment.s2.p1" />
        <P id="legal.payment.s2.p2" />
        <P id="legal.payment.s2.p3" />
        <P id="legal.payment.s2.p4" />
        <P id="legal.payment.s2.p5" />
        <P id="legal.payment.s2.p6" />
      </Section>

      <Section titleId="legal.payment.s3.title">
        <P id="legal.payment.s3.p1" />
        <ul>
          <Li id="legal.payment.s3.li1" />
          <Li id="legal.payment.s3.li2" />
          <Li id="legal.payment.s3.li3" />
        </ul>
        <P id="legal.payment.s3.p2" />
        <P id="legal.payment.s3.p3" />
      </Section>

      <Section titleId="legal.payment.s4.title">
        <P id="legal.payment.s4.p1" />
        <P id="legal.payment.s4.p2" />
      </Section>

      <Section titleId="legal.payment.s5.title">
        <P id="legal.payment.s5.p1" />
        <P id="legal.payment.s5.p2" />
        <P id="legal.payment.s5.p3" />
      </Section>

      <Section titleId="legal.payment.s6.title">
        <P id="legal.payment.s6.p1" />
        <P id="legal.payment.s6.p2" />
        <P id="legal.payment.s6.p3" />
      </Section>

      <Section titleId="legal.payment.s7.title">
        <P id="legal.payment.s7.p1" />
        <P id="legal.payment.s7.p2" />
        <P id="legal.payment.s7.p3" />
      </Section>

      <Typography variant="body2" align="center" sx={{ mt: 4, color: 'text.secondary' }}>
        <FormattedMessage id="legal.trademark" />
      </Typography>
    </ContentContainer>
  );
};

export default PaymentTerms;
